@for (line of lines; track line; let last = $last) {
  <p [ngClass]="{ 'mb-3': !last }" class="text-gray-900 m-0">
    {{ line }}
  </p>
}
